

const {PureComponent} = require("react");

class Nav extends PureComponent {
    render = () => {
        const { entries, visiblePageName } = this.props
        return <nav>{entries.map(entry =>
            <div className={entry.name === visiblePageName ? "selected": ""} key={entry.name} title={entry.tooltip}>
                {entry.name === visiblePageName ? entry.name : <a href={entry.hash} >{entry.name}</a>}
            </div>)}</nav>
    }
}

export default Nav
